<template>
    <div class="FM_financial">
        <div style="margin-bottom: 20px;">
            <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
        </div>
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="financeRecordForm" class="demo-form-inline">
                <el-form-item>
                    <el-date-picker
                            v-model="rangeDate"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="交易开始日期"
                            end-placeholder="交易结束日期"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions"
                            @change="pickerChange"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-input clearable v-model="financeRecordForm.terminal_sn" placeholder="请输入SN"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button
                            size="medium"
                            type="primary"
                            icon="el-icon-search"
                            style="font-size: 12px;"
                            @click="onSearch(financeRecordForm)"
                    >查询</el-button>
                    <el-button
                            size="small"
                            type="primary"
                            icon="el-icon-download"
                            :loading="downLoading"
                            @click="handleDownLoad(financeRecordForm)"
                    >导出数据</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <el-table
                    :data="financeRecordTable"
                    size="mini"
                    border
                    style="width: 100%"
                    v-loading="loading">
                <!-- ID -->
                <el-table-column
                        header-align="center"
                        align="center"
                        fixed
                        type="index"
                        label="ID"
                        min-width="80"
                ></el-table-column>
                <!-- 主机构 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="agent_name"
                        label="主机构"
                        min-width="150"
                ></el-table-column>
                <!-- 订单号 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="transaction_number"
                        label="订单号"
                        min-width="150"
                ></el-table-column>
                <!-- 终端类型 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="name"
                        label="终端类型"
                        min-width="150"
                ></el-table-column>
                <!-- SN码 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="terminal_sn"
                        label="SN码"
                        min-width="150"
                ></el-table-column>
                <!-- 终端归属代理商名称 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="real_name"
                        label="终端归属代理商名称"
                        min-width="150"
                ></el-table-column>
                <!-- 终端归属代理商手机号 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="phone"
                        label="终端归属代理商手机号"
                        min-width="150">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="scope.row.phone" placement="top">
                            <p>{{ scope.row.phone | desMobile }}</p>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 交易卡号 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="card_id"
                        label="交易卡号"
                        min-width="150"
                ></el-table-column>
                <!-- 商户号 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="merchant_number"
                        label="商户号"
                        min-width="150"
                ></el-table-column>
                <!-- 交易类型 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="p_name"
                        label="交易类型"
                        min-width="150"
                ></el-table-column>
                <!-- 卡类型 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="c_name"
                        label="卡类型"
                        min-width="150"
                ></el-table-column>
                <!-- 结算周期 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="s_name"
                        label="结算周期"
                        min-width="150"
                ></el-table-column>
                <!-- 交易时间 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="transaction_time"
                        label="交易时间"
                        min-width="150"
                ></el-table-column>
                <!-- 交易金额 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="transaction_money"
                        label="交易金额"
                        min-width="150"
                ></el-table-column>
                <!-- 操作 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        fixed="right"
                        label="操作"
                        min-width="140">
                    <template slot-scope="scope">
                        <el-button @click="handleEdit(scope.row)" type="text" size="small">分润</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <paginations
                    :currentPage="page.currentPage"
                    :pageSize="page.pageSize"
                    :total="page.total"
                    @watchCurrent="getCurrent"
                    @watchPageSize="getPageSize"
            ></paginations>
        </el-card>
    </div>
</template>

<script>
import paginations from '../../../components/pagination/paginations';
export default {
    name: "FM_agentaccountList",
    data() {
        return {
            currentDate: '',
            pickerOptions: {},
            rangeDate: [], //时间范围
            financeRecordTable: [], //表格
            financeRecordForm: {
                start_time: '',    //申请开始时间
                end_time: '',    //申请结束时间
                id: this.$route.query.id,
                terminal_sn:'',
                page: 1,
                limit: 10
            },
            page: {
                currentPage: 1, //当前页码
                pageSize: 10, //条数
                total: 0  //总数
            },
            loading: true,
            downLoading: false, //导出loading
            type: '',
        }
    },
    mounted() {
        this.getData(this.financeRecordForm);
    },
    created() {
        this.pickerOptions.disabledDate = (time) => { //禁用日期
            if (this.currentDate !== '') {
                let tempTime = 3600 * 1000 * 24 * 30;
                let timer = new Date(this.currentDate).getTime();
                let minTime = timer - tempTime;
                let maxTime = timer + tempTime;
                return time.getTime() < minTime || time.getTime() > Date.now() || time.getTime() > maxTime;
            }
            return time.getTime() > Date.now();
        }
        this.pickerOptions.onPick = ({ minDate, maxDate }) => { //当前选中的日期
            this.currentDate = minDate.getTime();
            if (maxDate) {
                this.currentDate = '';
            }
        }
    },
    components: {
        paginations
    },
    methods: {
        onSearch(financeRecordForm) {
            this.page.currentPage = 1;
            this.financeRecordForm.page = 1;
            // 表单提交
            this.getData(financeRecordForm);
        },
        //分页
        getCurrent(page) {
            this.loading = true;
            // 获取当前页修改的值
            this.page.currentPage = page;
            this.financeRecordForm.page = this.page.currentPage;
            this.financeRecordForm.limit = this.page.pageSize;
            this.getData(this.financeRecordForm);
        },
        getPageSize(limit) {
            this.page.currentPage = 1; //重置分页
            // 获取条数发生改变的值
            this.loading = true;
            this.page.pageSize = limit;
            this.financeRecordForm.page = this.page.currentPage;
            this.financeRecordForm.limit = limit;
            this.getData(this.financeRecordForm);
        },
        getData(params) {
            this.$api.post("transaction/transaction_hide_info", params, res => {
                let data = res.data;
                this.page.total = data.count; //总数
                this.financeRecordTable = data.list;
                //渲染结束后取消加载
                this.loading = false;
            })
        },
        handleEdit(row){
            var obj = {copy_id:row.id}
            this.$confirm('确定重新分润？', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'})
                .then(()=>{
                    this.$api.post("transaction/re_transaction", obj, res => {
                        if (res.code == 0) {
                            this.$message.success(res.msg);
                            this.getData(this.financeRecordForm);
                        }else{
                            this.$message.error(res.msg);
                        }
                    })
                })
                .catch(action=>{});
        },
        handleDefaultTime() { //默认获取三十天
            let date =this.$moment().endOf('day').format('x');
            this.financeRecordForm.end_time = this.$moment(Number(date)).format("YYYY-MM-DD HH:mm:ss");
            this.financeRecordForm.start_time = this.$moment(Number(date) - 3600 * 1000 * 24 * 31 +1).format("YYYY-MM-DD HH:mm:ss");
            this.rangeDate = [this.financeRecordForm.start_time, this.financeRecordForm.end_time];
        },
        pickerChange(DateArr) { //时间选择器
            this.financeRecordForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
            this.financeRecordForm.end_time = this._.isEmpty(DateArr) ? '' : this.$moment(Number(this.$moment(DateArr[1]).endOf('day').format('x'))).format("YYYY-MM-DD HH:mm:ss");
            this.rangeDate = [this.financeRecordForm.start_time, this.financeRecordForm.end_time];
        },
        handleDownLoad(financeRecordForm) { //导出
            this.downLoading = true;
            this.$api.post("transaction/transaction_hide_info_download", financeRecordForm, res => {
                if (res.code == 0) {
                    this.$message.success(res.msg);
                    var link=this.$file_url+res.data;
                    window.open(link)
                } else {
                    this.$message.error(res.msg);
                }
                //渲染结束后取消加载
                this.downLoading = false;
            })
        },
    }
};
</script>

<style lang="scss" scope>
.FM_financial {
  .realTitle {
    :nth-child(1) {
      font-size: 12px;
      font-weight: 700;
      color: #1e1e1e;
    }
    .imgParent {
      margin: 10px 0;
      // width: 500px;
      overflow: hidden;
      img {
        width: 100%;
        height: 250px;
        border-radius: 10px;
      }
    }
  }
  .el-dialog__header {
    padding: 20px 20px 0px;
  }
  .el-dialog__body {
    padding: 0px 20px 30px 20px;
  }
  .el-input__inner {
    font-size: 12px;
  }
  .el-form-item {
    margin-bottom: 5px;
  }
}
</style>
